import { FC } from 'react'
import { PureQueryOptions } from '@apollo/client'
import { useDomain } from 'context'
import format from 'date-fns/format'
import styled from 'styled-components'
import { useCurrentUserScrapDeleteCommunityMutation } from 'generated/graphql'
import ActivityLoadingList from '@app.feature/search/component/LoadingListItem'
import CoverLetterLoadingList from 'screens/CoverLetterScreen/LoadingListItem'
import CommunityScrapDeletedRow from './CommunityScrapDeletedRow'
import CommunityScrapItem, {
  CommunityScrapItemNode,
} from './CommunityScrapItem'

interface CommunityScrapListProps {
  isLoading: boolean
  isCoverLetter: boolean
  dataNodes: any[]
  queries: PureQueryOptions[]
}

const CommunityScrapList: FC<CommunityScrapListProps> = ({
  isLoading,
  isCoverLetter,
  dataNodes,
  queries,
}) => {
  const { xen } = useDomain()
  const [deleteUserScrapCommunity] =
    useCurrentUserScrapDeleteCommunityMutation()

  if (!dataNodes) {
    return <></>
  }

  const communityScrapListNodes: CommunityScrapItemNode[] = dataNodes
    .map((node) => {
      if (node?.__typename !== 'UserScrapCommunity') {
        return null
      }

      if (node?.post) {
        return {
          id: node?.id || '',
          boardTitle: node?.post?.board?.title,
          postCommentCount: node?.post?.commentCount
            ? `[${node?.post?.commentCount}]`
            : undefined,
          postCreatedAt: node?.post?.createdAt
            ? format(node?.post?.createdAt, 'yyyy.MM.dd HH:mm')
            : undefined,
          postID: node?.postID || '',
          postTitle: node?.post?.title ?? 'rmf',
          postViews: node?.post?.views
            ? `조회 ${node?.post?.views}`
            : undefined,
          postWriterName: node?.post?.nickname,
        }
      }

      return {
        id: node?.id || '',
        postID: node?.postID || '',
        postTitle: <CommunityScrapDeletedRow />,
        disabledOnClickTitle: true,
      }
    })
    .filter((node) => node !== null) as CommunityScrapItemNode[]

  const handleClickNode = (node) => {
    if (node?.postID && window?.location) {
      window.location.href = `//${xen}/community/${node.postID}`
    }
  }

  const handleDeleteNode = (node) => {
    if (node?.postID) {
      deleteUserScrapCommunity({
        variables: {
          postID: node.postID,
        },
        refetchQueries: queries,
      })
    }
  }

  if (isLoading) {
    if (!isCoverLetter) {
      return <ActivityLoadingList length={20} />
    }
    return <CoverLetterLoadingList length={20} />
  }

  if (dataNodes[0]?.__typename !== 'UserScrapCommunity') {
    return <></>
  }

  return (
    <StyledWrapper>
      {communityScrapListNodes.map((node) => {
        return (
          <CommunityScrapItem
            key={`Community-Scrap-Item-${node.id}`}
            node={node}
            onClickDeleteItem={() => handleDeleteNode(node)}
            onClickTitle={() => handleClickNode(node)}
            className="item"
          />
        )
      })}
    </StyledWrapper>
  )
}

export default CommunityScrapList

const StyledWrapper = styled.div`
  .item {
    border-bottom: 1px solid #eeeeee;
  }
`
